// @ts-ignore
// @ts-nocheck
import { toast } from 'react-toastify';
import api from '~/services/api';

const getAccessToken = () => {
  return localStorage.getItem('@UltragazEmpresarial:accessToken');
};

export const getCustomerIdUUID = async () => {
  const access_token = getAccessToken();

  try {
    const response = await api.get(`industrial/customer/v1/customers/me`, {
      headers: {
        'Content-Type': 'application/json',
        access_token,
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    });

    if (response.status === 200) {
      return response.data.id;
    }

    return null;
  } catch (err) {
    toast.error('Ocorreu um erro interno, tente novamente!');
  }
};

export const getTechnicalDocuments = async (siteId, searchValue = '') => {
  const access_token = getAccessToken();

  const queryParam = searchValue ? `/?name=${searchValue}` : '';

  try {
    const responseTechnicalDocuments = await api.get(
      `industrial/customer/v1/technical-documents/${siteId}${queryParam}`,
      {
        headers: {
          access_token,
          client_id: process.env.REACT_APP_CLIENT_ID,
        },
      }
    );

    if (responseTechnicalDocuments.status === 200) {
      return responseTechnicalDocuments.data;
    }

    return [];
  } catch {
    const msgError = `Ops! Parece que algo deu errado. Sugerimos que você converse com a Ully, a nossa assistente virtual, e esclareça  a sua solicitação.`;
    toast.error(msgError);
  }
};

export const getDownloadFile = async (linkRequest) => {
  const access_token = getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const parameters = {
    headers: header,
    responseType: 'blob',
  };

  const linkRequestArray = linkRequest.split('/').slice(4);
  const pdfName = linkRequestArray.join('/');

  try {
    const responseDocument = await api.get(
      `/industrial/customer/v1/maintenance-documents/redirect/${pdfName}`,
      parameters
    );

    if (responseDocument.status === 200) {
      const url = window.URL.createObjectURL(
        new Blob([responseDocument.data], { type: 'application/pdf' })
      );
      const linkDownload = document.createElement('a');
      linkDownload.href = url;
      linkDownload.setAttribute('download', `${pdfName}.pdf`);
      document.body.appendChild(linkDownload);
      linkDownload.click();
      linkDownload.parentNode.removeChild(linkDownload);

      return responseDocument;
    }
    return [];
  } catch (error) {
    toast.error('Ocorreu um erro ao solicitar o documento, tente novamente!');
  }
};

export const getTechnicalDocumentsOs = async () => {
  const access_token = getAccessToken();
  const siteCode = localStorage.getItem(
    '@UltragazEmpresarial:customerSiteCode'
  );

  try {
    const responseTechnicalDocumentsOs = await api.get(
      `industrial/customer/v1/customers/me/addresses/${siteCode}/os`,
      {
        headers: {
          access_token,
          client_id: process.env.REACT_APP_CLIENT_ID,
        },
      }
    );

    if (responseTechnicalDocumentsOs.status === 200) {
      return responseTechnicalDocumentsOs.data;
    }

    return [];
  } catch {
    toast.error(
      'Ocorreu um erro enquanto buscavamos os arquivos, tente novamente mais tarde!'
    );
  }
};

export const postMaintenanceDocumentsRequest = async ({
  numberOs,
  installBaseCode,
  contactIdSf,
  email = null,
}) => {
  const access_token = getAccessToken();
  const customerId = await getCustomerIdUUID();

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
    customerId,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const emails = [];

  if (email) {
    emails.push({ email });
  }

  const deliveryMethod = email ? 'EMAIL' : 'DOWNLOAD';

  const body = {
    numberOs,
    installBaseCode,
    deliveryMethod,
    emails,
    contactIdSf: contactIdSf !== 'undefined' ? contactIdSf : '',
  };

  try {
    return api.post(
      `industrial/customer/v1/maintenance-documents/request`,
      body,
      parameters
    );
  } catch (error) {
    toast.error('Ocorreu um erro ao solicitar o download, tente novamente!');
  }
};

export const getDownloadTechnicalDocuments = async ({
  customerSiteId,
  deliveryMethod,
  link,
  documentName,
  contactIdSf,
  email = null,
  listLinks = [],
}) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  const emails = [];

  if (email) {
    emails.push({ email });
  }

  const parameters = {
    method: 'POST',
    headers: header,
  };

  if (deliveryMethod === 'DOWNLOAD') {
    parameters.responseType = 'blob';
  }

  const links = [];

  if (listLinks.length > 0) {
    listLinks.map((linkValue) =>
      links.push({
        link: linkValue.link,
        documentName: linkValue.documentName,
      })
    );
  } else {
    links.push({
      link,
      documentName,
    });
  }

  const body = {
    customerSiteId,
    deliveryMethod,
    links,
    contactIdSf: contactIdSf !== 'undefined' ? contactIdSf : '',
    emails,
  };

  try {
    const responseDocument = await api.post(
      `industrial/customer/v1/technical-documents`,
      body,
      parameters
    );

    if (responseDocument.status === 200) {
      if (deliveryMethod === 'DOWNLOAD') {
        const url = window.URL.createObjectURL(
          new Blob([responseDocument.data], { type: 'application/pdf' })
        );
        const linkDownload = document.createElement('a');
        linkDownload.href = url;
        linkDownload.setAttribute('download', `${documentName}.pdf`);
        document.body.appendChild(linkDownload);
        linkDownload.click();
        linkDownload.parentNode.removeChild(linkDownload);
        return responseDocument;
      }
      return responseDocument;
    }
    if (responseDocument.status === 204) {
      return responseDocument;
    }
  } catch (error) {
    toast.error('Ocorreu um erro ao solicitar o documento, tente novamente!');
  }
};
